import { Button } from "@/modules/shadcn/ui/button";
import { useTranslation } from "react-i18next";
import { DiscoveredDevice } from "../../types";

interface DeviceListProps {
  devices: DiscoveredDevice[];
  onSelect: (url: string) => void;
}

export const DeviceList = ({ devices, onSelect }: DeviceListProps) => {
  const { t } = useTranslation("camera");
  if (devices.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        {t("discovery.noDevices")}
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {devices.map((device) => (
        <div
          key={device.url}
          className="flex items-center justify-between rounded-md border border-border p-3"
        >
          <div className="flex flex-col gap-0.5">
            <span className="text-sm font-medium">{device.host}</span>
            <span className="text-xs text-muted-foreground">
              {t("discovery.port", { port: device.port })}
            </span>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onSelect(device.url)}
          >
            {t("discovery.select")}
          </Button>
        </div>
      ))}
    </div>
  );
};
